<script lang="ts">
	import Modal from 'components/Modal/Modal.svelte';
	import Validation from 'components/Validation/Validation.svelte';
	import { _ } from 'utils/i18/i18n';
	import userStore from 'stores/user';
	import token from 'stores/token';
	import { getContext } from 'svelte';
	import { upsert } from 'services/watchlist/upsert';

	export let dark: boolean;
	export let active = false;
	export let uid = '';
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	export let watchlistData: any[] = [];
	const fetchData = getContext('fetchData');
	export let toggleModal: () => void;
	export let toggleWatchlist: (list: string) => void;
	export let watchlists;

	let watchlistName = '';
	let validationError = '';

	const createWatchlist = async () => {
		if (
			watchlistName.length > 0 &&
			!watchlists.includes(watchlistName.trim()) &&
			!!watchlistName.trim()
		) {
			const response = await upsert(uid, watchlistName.trim(), watchlistData, $token);
			userStore.set({
				isLoggedIn: true,
				...response.data.data,
			});
			$userStore.watchlist[watchlistName] = watchlistData;
			token.set(response.data.token);
			toggleWatchlist(watchlistName);
			active = false;
			watchlistName = '';
			validationError = '';
			toggleModal();
		} else if (watchlists.includes(watchlistName.trim())) {
			validationError = 'This watchlist name is already taken';
		} else if (watchlistName.trim().length === 0) {
			validationError = 'Watchlist name should not be empty or include special symbols';
		} else {
			validationError = 'Watchlist name should include only letters and numbers';
		}
		await fetchData();
	};
</script>

<Modal {dark} {active} {toggleModal}>
	<div class="add-modal-container" class:dark>
		<h2 class="add-modal-header" class:dark>
			{watchlistData?.length > 0 ? $_('watchlist.duplicate') : $_('watchlist.add')}
			{$_('watchlist.watchlist')}
		</h2>
		{#if validationError?.length > 0}
			<Validation message={validationError} />
		{/if}
		<input
			class="add-modal-input"
			value={watchlistName}
			placeholder={$_('watchlist.watchlistNamePlaceholder')}
			on:input={(e) =>
				(watchlistName = e.target.value
					.replaceAll(/[^a-zA-Z0-9 \u2800]/g, '')
					.replaceAll(/\s\s+/g, ' '))}
			class:dark
		/>
		<button class="add-modal-button" on:click={createWatchlist} class:dark
			>{watchlistData?.length > 0 ? $_('watchlist.duplicate') : $_('watchlist.add')}
			{$_('watchlist.watchlist')}</button
		>
	</div>
</Modal>

<style lang="scss">
	@import 'addWatchlistModal';
</style>
